module.exports = __webpack_public_path__ + "img/love.288928ad.png";